import { useParams } from 'react-router-dom';

import { Dialog, DialogContent } from '@/components/Dialog/Dialog';

import { HubForkRepo } from '../HubForkRepo/HubForkRepo';

export function ForkPromptDialog({
  open,
  onClose,
  inHub,
}: {
  open: boolean;
  onClose: () => void;
  inHub: boolean;
}) {
  const { repo: repoHandle } = useParams();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        title={`Fork prompt: ${repoHandle}`}
        className="max-h-[80vh] overflow-y-auto"
      >
        <HubForkRepo inHub={inHub} hideTitle={true} onSuccess={onClose} />
      </DialogContent>
    </Dialog>
  );
}
